export default function Loading() {
  // const currentYear = new Date().getFullYear()

  return (
    <div className="flex flex-col items-center bg-gradient justify-center w-full h-screen">
      <div className=" flex justify-center "></div>
      <div className="flex flex-col items-center justify-center w-[700px] h-[300px]">
        <svg
          className="spinner-ring spinner-xl"
          viewBox="25 25 50 50"
          strokeWidth="4"
          style={{ '--spinner-color': '255 255 255' } as React.CSSProperties}
        >
          <circle cx="50" cy="50" r="20" />
        </svg>
        <div className="text-center font-extrabold text-2xl pt-3 text-white">
          Please Wait
        </div>
      </div>
      {/* <div className="flex justify-center font-semibold pt-5 text-white">
                Copyright &copy; 2024 - {currentYear} by ASI Asia Pacific
            </div> */}
    </div>
  );
}
